import { render } from "./ViewLotteries.vue?vue&type=template&id=17f83856&scoped=true"
import script from "./ViewLotteries.vue?vue&type=script&lang=js"
export * from "./ViewLotteries.vue?vue&type=script&lang=js"

import "./ViewLotteries.vue?vue&type=style&index=0&id=17f83856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f83856"]])

export default __exports__